import { Link } from 'react-router-dom'

import { useBots } from '../api/bots'

/** "N bots en vivo" en la barra superior: el pulso de la flota a la vista
 *  desde cualquier pantalla. Cuenta los bots corriendo ahora (no pausados ni
 *  detenidos); sin ninguno, no se muestra — una pastilla en cero sería ruido
 *  permanente. Lleva a la lista de bots. */
export function LiveFleetPill() {
  const { data: bots } = useBots()
  const running = bots?.filter((bot) => bot.status === 'running').length ?? 0
  if (running === 0) return null

  return (
    <Link
      to="/bots"
      className="live-pill"
      title="Bots corriendo ahora — ir a la lista"
      aria-label={`${running} ${running === 1 ? 'bot corriendo' : 'bots corriendo'} ahora`}
    >
      <span className="pulse-dot" aria-hidden="true" />
      <span className="live-pill__text">
        {running} {running === 1 ? 'bot en vivo' : 'bots en vivo'}
      </span>
    </Link>
  )
}
